<!-- TODO Visszatenni, ha kell a publikus mező szerkesztés -->

<!--mat-checkbox
  class="easy-checkbox ms-auto"
  (change)="showVisibleFields = $event.checked"
  [checked]="showVisibleFields"
>
  {{ "SHARED.VISIBLE_FIELDS.TOGGLE" | translate }}
</mat-checkbox-->
<form
  [formGroup]="form"
  class="easy-form"
  appScrollToInvalidControl
  [appEditableWithRole]="['MERCHANT_ADMIN', 'TELESALES']"
>
  <!-- name  -->

  <fieldset
    class="group-in-two-columns w-100"
    [class.with-visible-fields]="showVisibleFields"
  >
    <legend>{{ TITLE + "SITE" | translate }}:</legend>
    <app-visible-fields-checkbox
      *ngIf="showVisibleFields"
      class="margin-top"
      fieldName="name"
    ></app-visible-fields-checkbox>
    <mat-form-field>
      <app-easy-input
        [label]="TITLE + 'SITE_NAME' | translate"
        formControlName="name"
        [placeholder]="PLACEHOLDER + 'SITE_NAME' | translate"
        [hideRequiredLabel]="false"
      ></app-easy-input>
    </mat-form-field>
  </fieldset>

  <!-- description -->

  <div
    class="in-one-column w-100"
    [class.with-visible-fields]="showVisibleFields"
  >
    <app-visible-fields-checkbox
      *ngIf="showVisibleFields"
      class="margin-top"
      fieldName="description"
    ></app-visible-fields-checkbox>

    <!-- label with lang: -->
    <!-- [title]="TITLE + 'SITE_DESCRIPTION_WITH_LANG'" -->
    <app-easy-localized-value-subform
      class="w-100"
      [formGroupAbstract]="form.get('description')!"
      [title]="TITLE + 'SITE_DESCRIPTION'"
      [textareaAutosizeMinRows]="3"
    ></app-easy-localized-value-subform>
  </div>

  <div
    class="group-in-two-columns w-100"
    [class.with-visible-fields]="showVisibleFields"
  >
    <app-visible-fields-checkbox
      class="margin-top"
      *ngIf="showVisibleFields"
      fieldName="types"
    ></app-visible-fields-checkbox>

    <mat-form-field>
      <app-easy-select
        [label]="TITLE + 'SITE_TYPES' | translate"
        formControlName="types"
        [labelAttribute]="'name'"
        [valueAttribute]="'value'"
        [multiple]="true"
        [options]="siteOptions"
        (ngModelChange)="setSiteOptions()"
      ></app-easy-select>
    </mat-form-field>
  </div>

  <!-- merchantTypes select -->

  <fieldset
    class="in-one-column w-100"
    [class.with-visible-fields]="showVisibleFields"
  >
    <app-visible-fields-checkbox
      class="mx-2 margin-top-minus"
      *ngIf="showVisibleFields"
      fieldName="merchantTypes"
    ></app-visible-fields-checkbox>
    <legend [class.left-space]="showVisibleFields">
      {{ "MERCHANT.TITLE.ACTIVITY" | translate }}:
    </legend>

    <div
      class="d-flex flex-column gap-4 merchant-types-container"
      [ngClass]="
        form.controls['merchantTypes'].touched &&
        form.controls['merchantTypes'].hasError('merchantTypeValidator')
          ? 'ng-invalid'
          : ''
      "
    >
      <mat-form-field>
        <app-easy-checkbox
          formControlName="hasExciseProductsOnSite"
          [label]="'MERCHANT.TITLE.HAS_EXCISE_PRODUCTS' | translate"
        ></app-easy-checkbox>
      </mat-form-field>
      <app-merchant-type-excise-subform
        class="w-100"
        [hasExciseProductsOnSite]="form.get('hasExciseProductsOnSite')?.value"
        (selectionChanged)="onMerchantTypeSelectionChange($event)"
      >
      </app-merchant-type-excise-subform>
    </div>
    <mat-error
      *ngIf="
        form.controls['merchantTypes'].touched &&
        form.controls['merchantTypes'].hasError('merchantTypeValidator')
      "
      class="mat-error"
    >
      {{ "REQUIRED" | translate }}
    </mat-error>
  </fieldset>

  <fieldset class="w-100">
    <legend>{{ TITLE + "OPERATING_LICENSE" | translate }}:</legend>

    <app-operating-license [siteId]="siteId"> </app-operating-license>
  </fieldset>

  <!-- phone  -->

  <fieldset class="w-100" [class.with-visible-fields]="showVisibleFields">
    <legend>{{ TITLE + "CONTACTS" | translate }}:</legend>

    <mat-checkbox
      class="easy-checkbox"
      (change)="useBasicDataPhone($event)"
      [disabled]="!basicData?.phone"
    >
      {{ "MERCHANT.SITES.EDIT.USE_BASIC_PHONE" | translate }}
    </mat-checkbox>

    <div class="group-in-two-columns">
      <app-visible-fields-checkbox
        class="margin-top"
        *ngIf="showVisibleFields"
        fieldName="phone"
      ></app-visible-fields-checkbox>
      <mat-form-field>
        <app-easy-phone-subform
          class="w-100"
          formControlName="phone"
          [label]="TITLE + 'phone'"
          [placeholder]="PLACEHOLDER + 'phone'"
          [hint]="HINT + 'phone'"
          [basicPhone]="basicData?.phone"
        ></app-easy-phone-subform>
      </mat-form-field>
    </div>

    <mat-checkbox
      class="easy-checkbox"
      [disabled]="!basicData?.email"
      (change)="useBasicDataEmail($event)"
    >
      {{ "MERCHANT.SITES.EDIT.USE_BASIC_EMAIL" | translate }}
    </mat-checkbox>

    <div class="group-in-two-columns">
      <app-visible-fields-checkbox
        class="margin-top"
        *ngIf="showVisibleFields"
        fieldName="email"
      ></app-visible-fields-checkbox>
      <mat-form-field class="w-100">
        <app-easy-input
          formControlName="email"
          [label]="TITLE + 'email' | translate"
          [placeholder]="PLACEHOLDER + 'email' | translate"
          formControlName="email"
          [hideRequiredLabel]="false"
        ></app-easy-input>
      </mat-form-field>
    </div>
  </fieldset>

  <!-- address -->

  <fieldset
    class="in-one-column w-100"
    [class.with-visible-fields]="showVisibleFields"
  >
    <app-visible-fields-checkbox
      *ngIf="showVisibleFields"
      class="margin-top-minus"
      fieldName="address"
    ></app-visible-fields-checkbox>

    <legend>{{ TITLE + "SITE_ADDRESS" | translate }}:</legend>

    <app-easy-address-subform
      class="w-100"
      title="{{ TITLE + 'SITE_ADDRESS' }}"
      [showCopyBasicDataButton]="true"
      [basicDataAddress]="basicData?.businessAddress"
      groupName="address"
    >
    </app-easy-address-subform>
  </fieldset>

  <!-- openingHours -->

  <fieldset
    class="in-one-column w-100"
    [class.with-visible-fields]="showVisibleFields"
  >
    <legend class="mb-0">
      {{ "SHARED.OPENING_HOURS.TITLE" | translate }}:
    </legend>
    <app-visible-fields-checkbox
      *ngIf="showVisibleFields"
      class="margin-top-minus pt-4"
      fieldName="openingHours"
    ></app-visible-fields-checkbox>

    <app-easy-opening-hours-subform
      class="w-100"
      formGroupName="openingHours"
    ></app-easy-opening-hours-subform>
  </fieldset>

  <!-- goodsReceivingHours -->

  <fieldset class="in-one-column w-100">
    <legend class="mb-0">
      {{ "MERCHANT.TITLE.GOODS_RECEIVING_HOURS" | translate }}:
    </legend>

    <app-easy-opening-hours-subform
      class="w-100"
      formGroupName="goodsReceivingHours"
    ></app-easy-opening-hours-subform>

    <mat-form-field class="w-100 mt-2">
      <app-easy-textarea
        formControlName="goodsReceivingComment"
        [label]="TITLE + 'GOODS_RECEIVING_COMMENT' | translate"
        [maxLength]="500"
        [showCharactersLeft]="true"
        [rows]="3"
        [resizable]="false"
      ></app-easy-textarea>
    </mat-form-field>
  </fieldset>

  <!-- deliveryServiceAvailable boolean -->

  <fieldset
    class="in-one-column w-100"
    [class.with-visible-fields]="showVisibleFields"
  >
    <legend>{{ TITLE + "SERVICE" | translate }}</legend>

    <app-visible-fields-checkbox
      *ngIf="showVisibleFields"
      fieldName="deliveryServiceFor"
    ></app-visible-fields-checkbox>
    <mat-form-field>
      <app-easy-checkbox
        formControlName="deliveryServiceAvailable"
        [label]="TITLE + 'DELIVERY_SERVICE_AVAILABLE' | translate"
        (ngModelChange)="onToggleDeliveryServiceAvailable()"
      ></app-easy-checkbox>
    </mat-form-field>

    <!-- deliveryServiceFor select -->

    <ng-container *ngIf="showDeliveryServiceFor && servedSegments.length">
      <app-visible-fields-checkbox
        class="margin-top"
        *ngIf="showVisibleFields"
        fieldName="deliveryServiceFor"
      ></app-visible-fields-checkbox>
      <mat-form-field class="w-100 max-w-100">
        <app-easy-select
          [label]="TITLE + 'DELIVERY_SERVICE_FOR' | translate"
          formControlName="deliveryServiceFor"
          [options]="servedSegments | sortMerchantTypes: 'value'"
          [labelAttribute]="'name'"
          [valueAttribute]="'value'"
          [translatePrefixForSelected]="'MERCHANT.CUSTOMER_SEGMENT.'"
          [differentLabelWhenSelected]="true"
          [showStatusLabel]="true"
          [multiple]="true"
          [hasEmptyOption]="false"
        >
        </app-easy-select>
      </mat-form-field>
    </ng-container>

    <!-- onSiteServiceAvailable boolean -->

    <app-visible-fields-checkbox
      *ngIf="showVisibleFields"
      fieldName="onSiteServiceAvailable"
    ></app-visible-fields-checkbox>
    <mat-form-field>
      <app-easy-checkbox
        formControlName="onSiteServiceAvailable"
        [label]="TITLE + 'ON_SITE_SERVICE_AVAILABLE' | translate"
        (ngModelChange)="onToggleOnSiteServiceAvailable()"
      ></app-easy-checkbox>
    </mat-form-field>

    <!-- onSiteServiceFor select -->

    <ng-container *ngIf="showOnSiteServiceFor && servedSegments.length">
      <app-visible-fields-checkbox
        class="margin-top"
        *ngIf="showVisibleFields"
        fieldName="onSiteServiceFor"
      ></app-visible-fields-checkbox>
      <mat-form-field class="w-100 max-w-100">
        <app-easy-select
          [label]="TITLE + 'ON_SITE_SERVICE_FOR' | translate"
          formControlName="onSiteServiceFor"
          [options]="servedSegments | sortMerchantTypes: 'value'"
          [labelAttribute]="'name'"
          [valueAttribute]="'value'"
          [translatePrefixForSelected]="'MERCHANT.CUSTOMER_SEGMENT.'"
          [differentLabelWhenSelected]="true"
          [showStatusLabel]="true"
          [multiple]="true"
          [hasEmptyOption]="false"
        >
        </app-easy-select>
      </mat-form-field>
    </ng-container>
  </fieldset>

  <!-- unpackagedProductsAvailable boolean -->

  <div
    class="in-one-column w-100"
    [class.with-visible-fields]="showVisibleFields"
  >
    <app-visible-fields-checkbox
      *ngIf="showVisibleFields"
      fieldName="unpackagedProductsAvailable"
    ></app-visible-fields-checkbox>
    <mat-form-field>
      <app-easy-checkbox
        formControlName="unpackagedProductsAvailable"
        [label]="TITLE + 'UNPACKAGED_PRODUCTS_AVAILABLE' | translate"
      ></app-easy-checkbox>
    </mat-form-field>
  </div>

  <!-- end -->

  <div class="button-row">
    <button
      type="button"
      mat-stroked-button
      color="primary"
      (click)="cancel.emit()"
    >
      {{ "MERCHANT.BTN.CANCEL" | translate | uppercase }}
    </button>
    <button
      mat-raised-button
      class="ms-auto"
      color="primary"
      (click)="onSubmit()"
    >
      <span *ngIf="router.url.includes('edit')">
        {{ "MERCHANT.BTN.UPDATE" | translate | uppercase }}
      </span>
      <ng-container *ngIf="!router.url.includes('edit')">
        <span *ngIf="sitesNumber ?? 0 > 0">
          {{ "MERCHANT.BTN.CREATE" | translate | uppercase }}
        </span>
        <span *ngIf="sitesNumber === 0">
          {{ "MERCHANT.BTN.NEXT" | translate | uppercase }}
        </span>
      </ng-container>
    </button>
  </div>
</form>
